import React, { useState } from 'react';
import { Query } from 'react-apollo';
import { Card, Col, Row, Statistic, DatePicker, Icon } from 'antd';
import moment from 'moment';
import { GET_DAILY_STATS } from '../../api/stats';
import Loading from '../../components/Loading';
import './index.css';

export default function Dashboard() {
  const [date, setDate] = useState(moment());

  const handleDateChange = (newDate) => {
    if (newDate) {
      setDate(newDate);
    }
  };

  const dateString = date.format('YYYY-MM-DD');

  return (
    <div className="dashboard-container">
      <div className="dashboard-header">
        <h2>数据看板</h2>
        <DatePicker 
          value={date} 
          onChange={handleDateChange} 
          allowClear={false}
        />
      </div>

      <Query query={GET_DAILY_STATS} variables={{ date: dateString }} fetchPolicy="network-only">
        {({ loading, error, data }) => {
          if (loading) return <Loading />;
          if (error) return <p>获取数据失败: {error.message}</p>;

          const { dailyStats } = data;

          return (
            <Row gutter={16} className="dashboard-cards">
              <Col xs={12} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="Message 数量"
                    value={dailyStats.messageCount}
                    prefix={<Icon type="message" />}
                    valueStyle={{ color: '#1890ff' }}
                  />
                </Card>
              </Col>
              <Col xs={12} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="评论数量"
                    value={dailyStats.commentCount}
                    prefix={<Icon type="message" />}
                    valueStyle={{ color: '#52c41a' }}
                  />
                </Card>
              </Col>
              <Col xs={12} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="新用户数"
                    value={dailyStats.newUserCount}
                    prefix={<Icon type="user-add" />}
                    valueStyle={{ color: '#faad14' }}
                  />
                </Card>
              </Col>
              <Col xs={12} sm={12} lg={6}>
                <Card>
                  <Statistic
                    title="登录人数"
                    value={dailyStats.loginUserCount}
                    prefix={<Icon type="user" />}
                    valueStyle={{ color: '#722ed1' }}
                  />
                </Card>
              </Col>
            </Row>
          );
        }}
      </Query>
    </div>
  );
}